export type PaperType = "objective" | "theory";

interface PaperToggleProps {
  value: PaperType;
  onChange: (paper: PaperType) => void;
  /** JAMB is entirely objective, so the toggle is not rendered at all. */
  hidden?: boolean | undefined;
}

/**
 * Objective (MCQ) / Theory.
 *
 * Hidden rather than disabled for JAMB: a disabled control invites the question
 * "why can't I have that?", and the answer — JAMB has no theory paper — is not
 * a restriction we imposed.
 */
export function PaperToggle({ value, onChange, hidden = false }: PaperToggleProps) {
  if (hidden) return null;

  return (
    <div
      role="group"
      aria-label="Paper type"
      className="flex gap-1 rounded-[var(--radius-chip)] border border-border bg-surface p-1"
    >
      {(
        [
          { id: "objective", label: "Objective (MCQ)" },
          { id: "theory", label: "Theory" },
        ] as const
      ).map((option) => (
        <button
          key={option.id}
          type="button"
          aria-pressed={value === option.id}
          onClick={() => onChange(option.id)}
          className={`min-h-9 flex-1 rounded-[var(--radius-chip)] px-3 text-[12.5px] font-semibold transition-colors ${
            value === option.id ? "bg-accent-tint text-text" : "text-text-muted"
          }`}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
